import * as Actions from './actions/actions'
import { settings } from '../../../settings/settings-util'
import { sendRequest } from '../../lib-alme-request/src/lib-alme-request';
const alterInputboxDisabledStatus = (store, passedSettings, newStatus) => {
    const selectedSettings = passedSettings || settings;
    const inputboxLockedBase = selectedSettings.stateLocations.Window.InputBoxLocked.Base;
    const isLockedLoc = selectedSettings.stateLocations.Window.InputBoxLocked.isInputBoxLocked;

    const payload = {
        inputboxDisabled: newStatus,
        stateLocation: `${inputboxLockedBase}.${isLockedLoc}`
    };

    store.dispatch(Actions.alterInputBoxDisabledStatus(payload));
};

const toggleInputBox = (newStatus, store, passedSettings, validationFunction) => {
    const selectedSettings = passedSettings || settings;
    if(validationFunction())
    {
        alterInputboxDisabledStatus(store, selectedSettings, newStatus);
        return true;
    }

    return false;
};

const enableInputBox = (store, passedSettings, validationFunction) => {
    return toggleInputBox(false, store, passedSettings, validationFunction);
};

const disableInputBox = (store, passedSettings, validationFunction) => {
    return toggleInputBox(true, store, passedSettings, validationFunction);
};

const SendRequestAndReEnableInputBox = (input, store, passedSettings, checkForLiveChatInitialization = false) => {
    Promise.resolve(sendRequest(input)).then((value) => {
        if(checkForLiveChatInitialization)
        {
            if(!value.response.responseActions.find(y => y.Name =="LiveChatStart"))
            {
                enableInputBox(store, passedSettings, () => true);
            }
        }
        else
        {
            enableInputBox(store, passedSettings, () => true);
        }
    });
};

export {
    enableInputBox,
    disableInputBox,
    SendRequestAndReEnableInputBox,
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/lib-inputbox-toggle/lib/lib-inputbox-toggle.js